import i18next from 'i18next';
import Toast from 'react-native-toast-message';

import { playSound } from '../sound';

const DEFAULT_TOAST_OPTIONS = {
	position: 'bottom' as const,
	visibilityTime: 4000,
	props: {
		height: 300,
		fontSize: 14,
	},
	text1Style: {
		fontSize: 16,
	},
	text2Style: {
		fontSize: 14,
		color: '#100f14ff',
	},
};

type ToastType = 'success' | 'error' | 'info';

// v1 played ToastError alongside every error message it raised (init.service,
// lobby, bonus modal); success/info toasts had no sound of their own.
const playToastSound = (type: ToastType) => {
	if (type === 'error') playSound('ToastError');
};

export const showToast = (type: ToastType, text1Key: string, fallback1: string, text2?: string) => {
	playToastSound(type);
	Toast.show({
		...DEFAULT_TOAST_OPTIONS,
		type,
		text1: i18next.t(text1Key, fallback1),
		text2,
	});
};

export const showPlainToast = (type: ToastType, text1: string, text2?: string) => {
	playToastSound(type);
	Toast.show({
		...DEFAULT_TOAST_OPTIONS,
		type,
		text1,
		text2,
	});
};

// convenience wrappers
export const toast = {
	success: (text1Key: string, fallback1: string, text2?: string) =>
		showToast('success', text1Key, fallback1, text2),
	error: (text1Key: string, fallback1: string, text2?: string) =>
		showToast('error', text1Key, fallback1, text2),
	errorText: (text1: string, text2?: string) => showPlainToast('error', text1, text2),
	info: (text1Key: string, fallback1: string, text2?: string) =>
		showToast('info', text1Key, fallback1, text2),
};
